import { useBreakpointRange, constants } from "@newsela/angelou";

const {
  breakpoints: { BreakpointRanges },
} = constants;

const useViewportIsNotDesktop = () => {
  const currentViewportRange = useBreakpointRange();

  const isNotDesktop = [
    BreakpointRanges.zeroToXs,
    BreakpointRanges.xsToSm,
    BreakpointRanges.smToMd,
  ].includes(currentViewportRange);

  return isNotDesktop;
};

export default useViewportIsNotDesktop;
